export const serverPath = {
  refresh: "/authentication/refreshtoken",
  generateOtp: "/authentication/otp/generateOtp",
  otpSignin: "/authentication/otp/signin",
  utm: "authentication/otp/utms",

  saveFriend: "/user/friendship/save",
  updateFriend: "/user/friendship/update",
  unblockedFriends: "/user/friendship/find-all-unblocked",
  blockedFriends: "/user/friendship/find-all-blocked",
  inviteFriend: "/user/friendship/invite",
  removeFriend: "/user/friendship/remove",
  generateLink: "/user/friendship/generate-link",
  decodeLink: "/user/friendship/decode-link",

  notifications: "/user/socket/subscribe",
  kickOut: "/user/socket/kick-out",

  findAvailableRoom: "/user/video/find-available-channel-token",
  generateRoomProvider: "/user/video/generate-room-provider",
  findChannelToken: "/user/video/channel-token",
  joinChannelCallback: "/user/video/join-channel-callback",
  leaveChannelCallback: "/user/socket/disconnect",
  findAdminChannelToken: "/user/video/find-admin-channel-token",
  cleanCache: "/user/video/clean-cache",
  videoToken: "/user/video/user-channel-token",
  saveToNotifiersList: "/user/video/save-to-notifiers-list",
  userConnected: "/user/video/join-user-channel",

  myUserDetails: "/user/user-details/me",
  saveProfile: "/user/user-details/save",
  getUserDetails: "/user/user-details/find-by-id",
  logOut: "/user/user-details/logout",
  communityList: "/user/user-details/search",
  communityCount: "/user/user-details/count",
  uploadPicture: "/user/user-details/upload-pic",
  getPhoneEmail: "/user/user-details/find-phone-email",
  updatePhoneEmail: "/user/user-details/update-user-phone-email",
  deactivateAccount: "/user/user-details/deactivate-account",
  isActiveAccount: "/user/user-details/activate",

  receivedInvitations: "/user/invitation/recived",
  updateInvitation: "/user/invitation/update",
  receivedInvitationsCount: "/user/invitation/count",

  reportUser: "/user/report/save",

  getUserSettings: "/user/user-settings/me",
  updateUserSettings: "/user/user-settings/save",
  saveUserSlots: "/user/user-settings/save-user-slots",

  getInterests: "/user/interest/find-all",
  sendBetaInvitations: "/marketing/sms/anonymous-invite",

  sendExpressions: "/dbwriter/user-expression",
  sendSpeechRecognition: "/dbwriter/user-transcript",
  sendFbEvent: "/dbwriter/send-fb-event",
};

export const loginEndpoints = [serverPath.generateOtp, serverPath.otpSignin] as const;

export const authorization = "Authorization";
export const bearer = "Bearer";
export const accessTokenName = "accessToken";
export const refreshTokenName = "refreshToken";
export const xRequestedWith = "x-requested-with";
export const emitterId = "emitter-id";

export const maxRetries = 5;
export const retryDelay = 3000;
const retryApiCounts: Record<string, number> = {};

export const shouldRetry = (url: string) => {
  if (retryApiCounts[url] === undefined) {
    retryApiCounts[url] = 0;
  }

  return retryApiCounts[url] < maxRetries;
};

export const increaseRetryCount = async (url: string) => {
  retryApiCounts[url] = retryApiCounts[url] ? retryApiCounts[url] + 1 : 1;

  // Wait for the retry delay
  await new Promise((resolve) => {
    setTimeout(resolve, retryDelay);
  });
};

export const resetRetryCount = (url: string) => {
  retryApiCounts[url] = 0;
};
